import React from 'react';
import { AlertTriangle, Loader } from 'lucide-react';
import '../styles/ConfirmDialog.css';

export default function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  isLoading = false,
  onConfirm,
  onCancel
}) {
  if (!open) return null;

  return (
    <div className="confirm-backdrop" role="presentation">
      <div className="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
        <div className={`confirm-icon confirm-icon--${variant}`}>
          <AlertTriangle size={20} />
        </div>
        <div className="confirm-copy">
          <h2 id="confirm-dialog-title">{title}</h2>
          {description && <p>{description}</p>}
        </div>
        <div className="confirm-actions">
          <button type="button" className="confirm-btn confirm-btn--secondary" onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </button>
          <button type="button" className={`confirm-btn confirm-btn--${variant}`} onClick={onConfirm} disabled={isLoading}>
            {isLoading && <Loader size={14} className="spinning" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
